<template>
  <v-layout row wrap class="colored-background">
    <v-flex xs12 sm12 md12 class="mt-5 text-xs-center">
      <img width="52%" :src="assetRoot + 'musicplus.png'" />
    </v-flex>
    <v-flex xs12 sm12 md12 class="mx-4 my-5 text-xs-center">
      <span class="page-title">Enter your new password</span>
    </v-flex>
    <v-flex xs12 sm12 md12 class="text-xs-center mb-5">
      <v-card class="mx-4 rounded-card">
        <v-container>
          <v-layout column>
            <v-text-field class="input-field" :disabled="isResetingPassword || passwordReset"  background-color="grey lighten-2" :type="showPassword1 ? 'text' : 'password'" :append-icon="showPassword1 ? 'visibility' : 'visibility_off'" @click:append="showPassword1 = !showPassword1" single-line outline hide-details v-model="i_password_1">
              <template v-slot:label>
                <span class="input-label">Password</span>
              </template>
            </v-text-field>
            <v-text-field class="mt-2 input-field" :disabled="isResetingPassword || passwordReset"  background-color="grey lighten-2" :type="showPassword2 ? 'text' : 'password'" :append-icon="showPassword2 ? 'visibility' : 'visibility_off'" @click:append="showPassword2 = !showPassword2" single-line outline hide-details v-model="i_password_2">
              <template v-slot:label>
                <span class="input-label">Password</span>
              </template>
            </v-text-field>
            <v-flex class="mt-3">
              <v-btn v-if="passwordReset" block flat disabled class="rounded-button-done" color="#4caf50">
                <template v-slot:default>
                  <span class="reset-button">PASSWORD RESET!</span>
                </template>
              </v-btn>
              <v-btn v-else block class="rounded-button" color="#2c7fff"
                :disabled="cantResetPassword || isResetingPassword"
                :loading="isResetingPassword"
                @click.stop="resetPassword"
              >
                <template v-slot:default>
                  <span v-if="cantResetPassword" class="reset-button-disabled">RESET</span>
                  <span v-else class="reset-button">RESET</span>
                </template>
              </v-btn>
            </v-flex>
            <v-flex class="mt-3" v-if="resetPasswordStatus === 'error'">
              <span class="error-message">{{ resetPasswordErrorMessage }}</span>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        i_password_1: '',
        i_password_2: '',

        showPassword1: false,
        showPassword2: false,
      }
    },
    methods: {
      resetPassword () {
        let payload = {
          env: this.env,
          body: {
            reset_password_code: this.$route.params.token,
            password: this.i_password_1
          }
        }
        this.$store.dispatch('RESET_PASSWORD', payload)
      }
    },
    computed: {
      ...mapGetters([
        'env',
        'assetRoot',

        'resetPasswordStatus',
        'resetPasswordErrorMessage'
      ]),
      cantResetPassword () {
        return this.$route.params.email === '' || this.$route.params.token === '' || this.i_password_1 === '' || this.i_password_2 === '' || (this.i_password_1 !== this.i_password_2)
      },
      isResetingPassword () {
        return this.resetPasswordStatus === 'progress'
      },
      passwordReset () {
        return this.resetPasswordStatus === 'done'
      }
    },
    mounted () {
      this.$nextTick(function () {

      })
    }
  }
</script>

<style scoped>
.colored-background {
  background-size: contain;
  background-image:url('https://storage.googleapis.com/mwm-appstore-assets/website_mwm/global_offer/BG-opti.jpg');
  background-color: #05151F;
}

.page-title {
  font-family: CenturyGothic;
  font-size: 1.5rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
}

.rounded-card{
  border-radius:11px;
}

.input-label {
  font-family: CenturyGothic;
  font-size: 18px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #abadad;
}

.input-field {
  font-family: CenturyGothic;
  font-size: 18px;
  background-color: #f8f8f8;
}

.rounded-button {
  border-radius: 11px;
  height: 48px;
  background-color: #2c7fff;
}

.rounded-button-done {
  border-radius: 11px;
  height: 72px;
  background-color: #4caf50;
}

.reset-button {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: #ffffff;
}

.reset-button-disabled {
  font-family: CenturyGothic;
  font-size: 23px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.87;
  letter-spacing: 1.28px;
  color: grey;
}

.error-message {
  font-family: CenturyGothic;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: red;
}
</style>
